import React from 'react'
import { compose } from 'recompose'
import FormCheckbox from 'components/forms/bases/FormCheckbox'
import FormSwitch from 'components/forms/bases/FormSwitch'
import FormSelect from 'components/forms/bases/FormSelect'
import FormAttributeRule from 'components/forms/FormAttributeRule'
import { updateObject } from 'helpers/objectHelpers'
import { withProductCardConfig } from '../../core/withElementConfig'

const ProductCardSettings = compose(
  withProductCardConfig(),
)(
  ({
    value,
    value: {
      hasBadge,
      originalPricePosition,
      shouldDisplayBrand,
      attributeRule = [],
      attributeStyle,
    },
    onChange,
    productCardConfig: {
      attributeRule: attributeRuleConfig = [],
      attributeStyle: attributeStyleConfig = [],
      brand = false,
    },
  }) => {
    const handleChange = (val, key) => {
      return onChange(updateObject(value, { [key]: val }))
    }
    return (
      <div>
        <FormCheckbox
          label="Show Badge"
          value={hasBadge}
          onChange={(val) => handleChange(val, 'hasBadge')}
        />
        {brand && (
          <FormCheckbox
            label="Show Brand"
            value={shouldDisplayBrand}
            onChange={(val) => handleChange(val, 'shouldDisplayBrand')}
          />
        )}
        <FormSelect
          label="Orginal Price Position"
          value={originalPricePosition}
          options={['top', 'bottom']}
          onChange={(val) => handleChange(val, 'originalPricePosition')}
        />
        {attributeStyleConfig.length > 1 && (
          <FormSelect
            label="Attribute style"
            value={attributeStyle}
            options={attributeStyleConfig}
            onChange={(val) => handleChange(val, 'attributeStyle')}
          />
        )}
        {attributeRuleConfig.length > 0 && (
          <FormAttributeRule
            value={attributeRule}
            mapper={attributeRuleConfig}
            onChange={(val) => handleChange(val, 'attributeRule')}
          />
        )}
      </div>
    )
  }
)

ProductCardSettings.propTypes = {}
ProductCardSettings.defaultProps = {}

export default ProductCardSettings



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/productCard/ProductCardSettings.js